/** Sidebar de navegação (desktop): filtro local com sinônimos + seções por
 *  categoria com item ativo destacado. Porte do filterTutorials do V1. */
import { useMemo, useState } from 'react';
import { filterCategories } from '../search';

export function Sidebar({
  activeKey,
  onOpen,
}: {
  activeKey: string | null;
  onOpen: (key: string) => void;
}) {
  const [filter, setFilter] = useState('');
  const cats = useMemo(() => filterCategories(filter), [filter]);

  return (
    <div className="bg-white border border-gray-200 rounded-2xl overflow-hidden shadow-sm">
      {/* Filtro da sidebar */}
      <div className="p-3 border-b border-gray-100">
        <div className="relative">
          <i className="fas fa-filter absolute left-3 top-1/2 -translate-y-1/2 text-slate-400 text-xs" />
          <input
            type="text"
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
            placeholder="Filtrar menu…"
            className="w-full bg-gray-100 border border-gray-200 rounded-lg pl-9 pr-3 py-2 text-xs text-slate-800 placeholder-slate-400 outline-none focus:bg-white focus:border-indigo-500 transition"
          />
        </div>
      </div>

      <nav className="max-h-[calc(100vh-220px)] overflow-y-auto custom-scroll py-2">
        {cats.length === 0 ? (
          <div className="px-4 py-8 text-center text-slate-400 text-sm">
            <i className="fas fa-search-minus text-2xl mb-2 block" />
            Nenhum tutorial encontrado.
          </div>
        ) : (
          cats.map((cat) => (
            <div key={cat.slug} className="mb-1">
              <div className="px-4 pt-3 pb-1 text-[10px] font-bold text-slate-400 uppercase tracking-wider">
                {cat.title}
              </div>
              {cat.items.map((it) => {
                const active = it.key === activeKey;
                return (
                  <button
                    key={it.key}
                    onClick={() => onOpen(it.key)}
                    className={`w-full text-left px-4 py-2.5 text-sm flex items-center gap-2 transition border-l-2 ${
                      active
                        ? 'bg-indigo-50 text-indigo-700 border-indigo-600 font-bold'
                        : 'text-slate-600 border-transparent hover:bg-gray-50 hover:text-slate-900'
                    }`}
                  >
                    <i className={`${it.icon} w-5 text-center text-xs ${active ? 'text-indigo-600' : 'text-slate-400'}`} />
                    <span className="truncate">{it.label}</span>
                  </button>
                );
              })}
            </div>
          ))
        )}
      </nav>
    </div>
  );
}
